export default {
    computed: {
        user() {
            return this.$store.state.user
        },
        searchQuery() {
            return this.$store.state.search
        },
        filters() {
            return this.$store.state.filters
        },
        defaultFilters() {
            return this.$store.state.defaultFilters
        },
        filtersSet() {
            for (var i in this.filters) {
                if (this.filters[i] != this.defaultFilters[i]) {
                    return true
                }
            }
            return false
        },
    },
    methods: {
        getUserBeats(page, limit = 20, sharedBeatId, {playlistId} = {}) {

            const defaultOrder = 'score'
            let data = {
                page: page,
                limit: limit,
                search: this.searchQuery,
                user_id: this.user.id,
                expand: 'tags',
                beat_id: sharedBeatId
            }
            if (playlistId) {
                data.collection = playlistId
            }
            Object.assign(data, this.filters)

            if((this.filtersSet && !data.order) || this.searchQuery != "")
                data.order = defaultOrder

            let path = (this.filtersSet || this.searchQuery != "") && !playlistId ? '/beats/search' : `/users/${this.user.id}/beats`
            return this.$http.get(ab.apiUrl + path, {params: data})

        },
        getBeatPlaylist(id, sharedBeatId) {
            return this.$http.get(`${ab.apiUrl}/collections/${id}`, {params: {
                expand: 'playlist,playlist.moods,playlist.tags',
                beat_id: sharedBeatId
            }})

        },
        filterBeatPlaylist(list) {
            let filtered = list;

            // Search
            if (this.searchQuery != "") {
                filtered = _.filter(filtered, (el) => {
                    if (el.name.toLowerCase().search(this.searchQuery.toLowerCase().trim()) >= 0) return true;
                });
            }

            // Genre
            if (this.$store.state.filters.genre != 0) {
                filtered = _.filter(filtered, (el) => {
                    if (el.genre.id == this.$store.state.filters.genre) return true;
                });
            }

            // Mood
            if (this.$store.state.filters.moods != '') {
                filtered = _.filter(filtered, (el) => {
                    for (var i = 0; i < el.moods.length; i++) {
                        if (el.moods[i].id == this.$store.state.filters.moods) return true
                    }
                })
            }

            // Tags
            if (this.$store.state.filters.tags != '') {
                filtered = _.filter(filtered, (el) => {
                    for (var i = 0; i < el.tags.length; i++) {
                        if (el.tags[i].id == this.$store.state.filters.tags) return true
                    }
                })
            }

            // Date Added
            if (this.$store.state.filters.added != 0) {
                let date = new Date();
                date.setDate(date.getDate() - this.$store.state.filters.added);

                filtered = _.filter(filtered, (el) => {

                    let added = new Date(el.dateAdded);
                    if (added > date) return true;
                });
            }

//                // Price
//                filtered = _.filter(filtered, (el) => {
//                    if ('freeDownload' in el && el.freeDownload) return true;
//
//                    var minPrice = el.minPrice();
//                    if (minPrice <= this.$store.state.filters.maxPrice) return true;
//                });

            // Order
            if (this.$store.state.filters.order != '') {
                filtered = filtered.sort((a, b) => {
                    let aDate = new Date(a.dateAdded);
                    let bDate = new Date(b.dateAdded);

                    switch (this.$store.state.filters.sort) {
                        case 'latest':
                            return bDate - aDate;
                            break;
                        case 'oldest':
                            return aDate - bDate;
                            break;
                        case 'plays':
                            return b.plays - a.plays;
                            break;
                    }
                })
            }

            return filtered
        },
        getGenreFromIdOrAlias(idOrAlias) {
            let identifier = (isNaN(parseInt(idOrAlias))) ? 'alias' : 'id'

            for (let i = 0; i < this.$store.state.genres.length; i++) {
                let genre = this.$store.state.genres[i]

                if (idOrAlias == genre[identifier]) {
                    return genre
                }
            }
            return false
        },
        getMoodFromId(id) {
            for (let i = 0; i < this.$store.state.moods.length; i++) {
                let mood = this.$store.state.moods[i]

                if (id == mood.id) {
                    return mood
                }
            }
            return false
        },
        setFiltersFromUrlQuery() {

            let filters = jQuery.extend({}, this.defaultFilters)
            if (this.$route.query.q == undefined) {
                this.$store.commit("searchQuery", {searchQuery: ""})
            }

            for (var i in this.$route.query) {
                if (i == "q") {
                    this.$store.commit("searchQuery", {searchQuery: this.$route.query[i]})
                    continue
                }

                if (filters[i] != undefined) {
                    switch (i) {
                        case "genre":
                            let genre = this.getGenreFromIdOrAlias(this.$route.query[i])
                            if (genre) filters[i] = genre.id
                            break
                        default:
                            filters[i] = this.$route.query[i]
                    }
                }
            }

            this.setBeatFilters(filters)
        },
        setUrlQueryFromBeatFilters() {
            let queryParams = this.getQueryParams(this.filters)

            this.$router.push({name: this.$route.name, path: this.$route.path, query: queryParams})

        },
        getQueryParams(filters) {
            let queryParams = {}

            if (filters.added != this.defaultFilters.added) {
                queryParams.added = filters.added
            }
            if (filters.order != this.defaultFilters.order) {
                queryParams.order = filters.order
            }
            if (filters.genre != this.defaultFilters.genre) {
                queryParams.genre = this.getGenreFromIdOrAlias(filters.genre).alias
            }
            if (filters.moods != this.defaultFilters.moods) {
                queryParams.moods = filters.moods
            }
            if (filters.tags != this.defaultFilters.tags) {
                queryParams.tags = filters.tags
            }

            return queryParams
        },
        setBeatFilters(filters) {
            this.$store.commit('setBeatFilters', {
                filters: filters
            })
        },
        getUserBeat(id) {
            return this.$http.get(`${ab.apiUrl}/beats/${id}`,  {params: {expand: 'user,commenters,tags,moods'}})
        },
        getUserBeatByAlias(alias) {
            return this.$http.get(`${ab.apiUrl}/beats/${this.user.username}/${alias}`,  {params: {expand: 'user,commenters,tags,moods'}})
        },
        getUserChart(duration, limit = 100) {
            let params = {
                limit: limit,
                page: 1,
                order: 'sales_' + duration,
                user_id: this.user.id,
                expand: 'tags'
            }

            return this.$http.get(`${ab.apiUrl}/beats/search`, {params: params})
        }

    }
}
